<template>
    <v-dialog v-model="displayCouponModal" v-if="couponPageUrl" width="800">
        <v-card max-height="600">
            <v-card-text class="content pr-0">
                <iframe
                    v-if="couponPageUrl"
                    :src="couponPageUrl"
                    frameborder="0"
                    width="100%"
                    height="100%"
                ></iframe>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="displayCouponModal = false" color="primary">
                    {{ 'shut down' | translation }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.content {
    height: 50vh;
}
</style>

<script>
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

export default {
    name: 'CouponPageModal',
    data() {
        return {
            couponPageUrl: null,
        };
    },
    created() {
        let couponCode = this.$route.query.cp;

        if (couponCode) {
            this.$router.replace({
                ...this.$route,
                query: {
                    ...this.$route.query,
                    cp: undefined,
                },
            });

            this.applyCoupon({ couponCode, prioritizeNewCoupon: true }).then(coupon => {
                if (coupon && coupon.pageId) {
                    this.loadPage({
                        pageId: coupon.pageId,
                    }).then(page => {
                        if (page && page.url) {
                            this.couponPageUrl = page.url;
                        } else {
                            this.loadErrorPage(coupon);
                        }
                    }).catch(e => {
                        this.loadErrorPage(coupon);
                    });
                } else if (coupon.errorPage) {
                    this.loadErrorPage(coupon);
                } else {
                    this.displayCouponModal = false;
                }
            }).catch(e => {
                if (
                    e.graphQLErrors &&
                    e.graphQLErrors.length &&
                    e.graphQLErrors[0].message &&
                    e.graphQLErrors[0].message.errorPage
                ) {
                    this.loadErrorPage(e.graphQLErrors[0].message);
                } else {
                    this.displayCouponModal = false;
                }
            });
        }
    },
    computed: {
        ...mapState('Coupon', [
            'couponCode',
        ]),
        ...mapGetters('Coupon', [
            'getDisplayCouponModal',
        ]),
        displayCouponModal: {
            get() {
                return this.getDisplayCouponModal;
            },
            set(value) {
                this.setDisplayCouponModal(value);
            },
        },
    },
    methods: {
        ...mapMutations('Coupon', [
            'setDisplayCouponModal',
            'addCouponCode',
        ]),
        ...mapActions('PageContent', [
            'loadPage',
        ]),
        ...mapActions('Coupon', [
            'applyCoupon',
        ]),
        loadErrorPage(coupon) {
            this.loadPage({
                path: coupon.errorPage,
            }).then(page => {
                if (page && page.url) {
                    this.couponPageUrl = page.url;
                } else {
                    this.displayCouponModal = false;
                }
            }).catch(e => {
                this.displayCouponModal = false;
            });
        }
    },
};
</script>